import { render, staticRenderFns } from "./TemplateType.vue?vue&type=template&id=3b93501e&scoped=true&"
import script from "./TemplateType.vue?vue&type=script&lang=ts&"
export * from "./TemplateType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b93501e",
  null
  
)

export default component.exports